// extracted by mini-css-extract-plugin
export default {"label":"Input_label__6-m-v","title":"Input_title__xykRG","input":"Input_input__1HDO2"};